import React from "react";
/* asset imports */
import proteinCart1 from "../assets/images/proteins/proteins-1.png";
import proteinCart2 from "../assets/images/proteins/proteins-2.png";
import proteinCart3 from "../assets/images/proteins/proteins-3.png";
import MainCartModal from "./modals/MainCartModal";

const ProteinsCartLarge = ({
  handleCartClick,
  handleCartItemClick,
  activeCartData,
}) => {
  return (
    <>
      <div className="carts-main-wrapper">
        <div className="close-icon" onClick={() => handleCartClick(0)}>
          <span className="material-symbols-rounded">close</span>
        </div>
        <div className="cart-large proteins-cart-empty">
          <img
            src={proteinCart1}
            alt=""
            className="inner-img-var-2-1"
            onClick={() => handleCartItemClick("animal-based-proteins")}
          />
          <img
            src={proteinCart2}
            alt=""
            className="inner-img-var-2-2"
            onClick={() => handleCartItemClick("plant-based-proteins")}
          />
          <img
            src={proteinCart3}
            alt=""
            className="inner-img-var-2-3"
            onClick={() => handleCartItemClick("nuts-seeds-butters")}
          />
        </div>
      </div>
      <MainCartModal activeCartData={activeCartData} />
    </>
  );
};

export default ProteinsCartLarge;
